import React from 'react';
import { array, string, node, func, oneOfType } from 'prop-types';
import { useSwipeable } from 'react-swipeable';
import classNames from 'classnames';
import { sendMixPanelEvent } from '../utils/biEvents';
import '../style.scss';

const SimpleSlider = (props) => {

    const onSwiped = () => {
        const { mixpanelEvent } = props;

        if (mixpanelEvent) {
            sendMixPanelEvent({ eventName: mixpanelEvent });
        }
    };

    const handlers = useSwipeable({
        onSwiped
    });

    const {
        items,
        Component
    } = props;

    const simpleSliderClassname = classNames('simple-slider');

    return (
        <div className={simpleSliderClassname} {...handlers}>
            {
                items.map((props, index) => (
                    <div className="slick-slide" key={index}>
                        <Component {...props} pos={index + 1}/>
                    </div>
                ))
            }
        </div>
    );
};

SimpleSlider.propTypes = {
    items: array.isRequired,
    Component: oneOfType([
        node,
        func
    ]).isRequired,
    mixpanelEvent: string
};

export default SimpleSlider;
